import { render, staticRenderFns } from "./pendamping-ppbpemda.vue?vue&type=template&id=632a4427&scoped=true"
import script from "./pendamping-ppbpemda.vue?vue&type=script&lang=js"
export * from "./pendamping-ppbpemda.vue?vue&type=script&lang=js"
import style0 from "./pendamping-ppbpemda.vue?vue&type=style&index=0&id=632a4427&prod&lang=scss"
import style1 from "./pendamping-ppbpemda.vue?vue&type=style&index=1&id=632a4427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a4427",
  null
  
)

export default component.exports